import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdResource } from "../../../../../constants/IdResource";
import { IdStyles } from "../../../../../less/IdStyles";
import { selectInventoryResourceInfo } from "../../../../../selectors/selectInventoryInfo";
import { IdLoca } from "../../../../../utils/i18n/IdLoca";
import { utilSkipProcess } from "../../../../../utils/utilSkipProcess";
import { ButtonSecondaryMedium } from "../../../../generic/common/ButtonSecondaryMedium";
import { Icon } from "../../../../generic/icon/Icon";
import { IdIcon } from "../../../../generic/icon/IdIcon";
import { NumberFormat } from "../../../../generic/number-format/NumberFormat";
import { TextLoca } from "../../../../generic/text/TextLoca";
import { actionQuestSkip } from "../actionQuests";
var QuestSkipButtonDOM = function (props) {
    var questId = props.questId, taskIndex = props.taskIndex, taskCompleted = props.taskCompleted, skipCost = props.skipCost, currentAmount = props.currentAmount, requiredAmount = props.requiredAmount, onTrySkip = props.onTrySkip, playerGold = props.playerGold;
    if (skipCost === undefined || taskCompleted) {
        return React.createElement(React.Fragment, null);
    }
    var currentSkipCost = skipCost;
    if (currentAmount && requiredAmount && currentAmount < requiredAmount) {
        currentSkipCost = utilSkipProcess.calculateQuestTaskSkipCost(currentAmount, requiredAmount, skipCost);
    }
    var onClick = function () {
        return onTrySkip(playerGold || Long.ZERO, Long.fromValue(currentSkipCost), actionQuestSkip(questId, taskIndex, currentSkipCost));
    };
    return (React.createElement(ButtonSecondaryMedium, { onClick: onClick },
        React.createElement("div", { className: "flex flex--stacked flex--guts" },
            React.createElement("div", { className: "" + IdStyles.TextBoldPrimary },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.skip })),
            React.createElement("div", { className: "flex flex--guts" },
                React.createElement(Icon, { icon: IdIcon.GoldIcn, styleId: IdStyles.IconMedium }),
                React.createElement("div", null,
                    React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondary, amount: currentSkipCost }))))));
};
var mapState = function (state) { return ({
    playerGold: selectInventoryResourceInfo(state, IdResource.Gold).amount,
}); };
export var QuestSkipButton = connect(mapState)(QuestSkipButtonDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/QuestSkipButton.tsx
// module id = 128
// module chunks = 3